export const UrduSoundsData = [
  {
    title: `alif_madda`,
    audioUrl: require("../audios/alif_madda.mpeg"),
    thumbnail: 'https://lh3.googleusercontent.com/d/1bmKkokkuJEnK6jua0m9b7-vD9Jt2qbFp=s1000?authuser=0'
  },
  {
    title: `alif`,
    audioUrl: require("../audios/alif.mpeg"),
    thumbnail: 'https://lh3.googleusercontent.com/d/1BWODYsifgnoKB6VE7Ff4LLEdKxYuUITy=s1000?authuser=0'
  },
  {
    title: `bey`,
    audioUrl: require("../audios/bey.mpeg"),
    thumbnail: 'https://lh3.googleusercontent.com/d/1OcwPvv8tobHnIimsBdbBEBJLcNlfSON1=s1000?authuser=0'
  },
  {
    title: `pey`,
    audioUrl: require("../audios/pey.mpeg"),
    thumbnail: 'https://lh3.googleusercontent.com/d/1eF-5Yx9q10KyaB75lGgS2QUXjw_ZpPel=s1000?authuser=0'
  },
  {
    title: `tey`,
    audioUrl: require("../audios/tey.mpeg"),
    thumbnail: 'https://lh3.googleusercontent.com/d/12WiSHcu-f42TKBn9Di8Kz4tWkHxWmfTG=s1000?authuser=0'
  },
  {
    title: `tay`,
    audioUrl: require("../audios/tay.mpeg"),
    thumbnail: 'https://lh3.googleusercontent.com/d/1AgMSzHdL2GsCuqGMNzjg7lPqAWzRTmUL=s1000?authuser=0'
  },
  {
    title: `say`,
    audioUrl: require("../audios/say.mpeg"),
    thumbnail: 'https://lh3.googleusercontent.com/d/1RpAl_KmeSgYA7Y-jjhmuCLPQbx8mi_1b=s1000?authuser=0'
  },
  {
    title: `jeem`,
    audioUrl: require("../audios/jeem.mpeg"),
    thumbnail: 'https://lh3.googleusercontent.com/d/1tnIWh5yHtvjUikoDiX6pibM56edN_YvZ=s1000?authuser=0'
  },
  {
    title: `chey`,
    audioUrl: require("../audios/chey.mpeg"),
    thumbnail: 'https://lh3.googleusercontent.com/d/1cxZrpSdK9X0BoXqQx-z9d0J4JW2q_jV_=s1000?authuser=0'
  },
  {
    title: `haa`,
    audioUrl: require("../audios/haa.mpeg"),
    thumbnail: 'https://lh3.googleusercontent.com/d/1p_DHiegPTTw2jdwjy5DNN1aALE6yE2aq=s1000?authuser=0'
  },
  {
    title: `kha`,
    audioUrl: require("../audios/kha.mpeg"),
    thumbnail: 'https://lh3.googleusercontent.com/d/13Aqv1UNA704Dp8abDrXapNMrjuvaviC=s1000?authuser=0'
  }
];